import axios from "axios";

export default {
    namespaced: true,

    state: {
        toponyms: [],
        totalCount: 0,
        filteredResultsCount: 0,
        newestToponym: {},
        newestToponyms: [],
        allToponymsFilters: {
            sort: "id",
            search: null,
            sortOrder: "desc",
            user_id: null,
            letter: null,
            alphabetically: null,
            administrative_territory_id: null,
            offset: 0,
            limit: 50,
        },
        topActiveUsers: [],
        topAdministrativeTerritories: [],
        allToponymTypes: [],
    },

    getters: {
        toponyms(state) {
            return state.toponyms;
        },
        totalCount(state) {
            return state.totalCount;
        },
        newestToponym(state) {
            return state.newestToponym;
        },
        filteredResultsCount(state) {
            return state.filteredResultsCount;
        },
        newestToponyms(state) {
            return state.newestToponyms;
        },
        topActiveUsers(state) {
            return state.topActiveUsers;
        },
        topAdministrativeTerritories(state) {
            return state.topAdministrativeTerritories;
        },
        allToponymTypes(state) {
            return state.allToponymTypes;
        },
    },

    mutations: {
        SET_TOPONYMS(state, list) {
            state.toponyms = list;
        },
        SET_NEWEST_TOPONYM(state, newestToponym) {
            state.newestToponym = newestToponym;
        },
        SET_TOTAL_COUNT(state, count) {
            state.totalCount = count;
        },
        SET_FILTERED_RESULTS_TOTAL_COUNT(state, count) {
            state.filteredResultsCount = count;
        },
        SET_NEWEST_TOPONYMS(state, toponyms) {
            state.newestToponyms = toponyms;
        },
        SET_FILTERS(state, value) {
            state.allToponymsFilters = value;
        },
        SET_TOP_ACTIVE_USERS(state, value) {
            state.topActiveUsers = value;
        },
        SET_TOP_ADMINISTRATIVE_TERRITORIES(state, value) {
            state.topAdministrativeTerritories = value;
        },
        SET_TOPONYM_TYPES(state, value) {
            state.allToponymTypes = value;
        },
    },
    actions: {
        async fetchAllToponyms({ commit, state }) {
            return await axios
                .get("/api/all-toponyms", {
                    params: state.allToponymsFilters,
                })
                .then((response) => {
                    commit("SET_TOPONYMS", response.data.toponyms);
                    commit(
                        "SET_FILTERED_RESULTS_TOTAL_COUNT",
                        response.data.filterd_results_count
                    );
                    return response;
                });
        },
        async fetchAllToponymsForMap({ commit, state }) {
            return await axios
                .get("/api/all-toponyms-for-map", {
                    params: state.allToponymsFilters,
                })
                .then((response) => {
                    return response;
                });
        },
        async getNewestToponyms({ commit, state }) {
            await axios.get("/api/newest-toponyms").then((response) => {
                commit("SET_NEWEST_TOPONYMS", response.data);
            });
        },
        async getNewestToponym({ commit }) {
            await axios.get("/api/newest-toponym").then((response) => {
                commit("SET_NEWEST_TOPONYM", response.data);
            });
        },
        async getAllToponymsCount({ commit }) {
            await axios.get("/api/get-all-toponyms-count").then((response) => {
                commit("SET_TOTAL_COUNT", response.data);
            });
        },
        async saveNewToponym({ commit }, payload) {
            // const config = {
            //     headers: {
            //         "content-type": "multipart/form-data",
            //     },
            // };
            await axios
                .post("/api/create-toponym", payload)
                .then((response) => {
                    // commit('SET_NEWEST_TOPONYM', response.data);
                });
        },
        async getToponym({ commit }, id) {
            return await axios.get("/api/get-toponym", {
                params: { id },
            });
        },
        async saveToponymChanges({ commit }, payload) {
            await axios
                .post("/api/update-toponym", payload)
                .then((response) => {});
        },
        async deleteToponymFromDB({ commit }, id) {
            await axios
                .post("/api/delete-toponym", { id })
                .then((response) => {});
        },
        async unlinkParalelForm({ commit }, data) {
            await axios
                .post("/api/delete-toponym-paralel-form", data)
                .then((response) => {});
        },
        async saveNewToponymComment({ commit }, payload) {
            await axios
                .post("/api/create-toponym-comment", payload)
                .then((response) => {
                    // commit('SET_NEWEST_TOPONYM', response.data);
                });
        },
        async getTopActiveUsers({ commit }, limit = 5) {
            await axios
                .get("/api/top-active-users", {
                    params: { limit },
                })
                .then((response) => {
                    commit("SET_TOP_ACTIVE_USERS", response.data);
                });
        },
        async getTopAdministrativeTerritories({ commit }, limit = 5) {
            await axios
                .get("/api/top-administrative-territories", {
                    params: { limit },
                })
                .then((response) => {
                    commit("SET_TOP_ADMINISTRATIVE_TERRITORIES", response.data);
                });
        },
        async fetchAllToponymTypes({ commit, state }) {
            return await axios
                .get("/api/all-toponym-types")
                .then((response) => {
                    const sorted = response.data.slice().sort((a, b) =>
                        a.name.localeCompare(b.name, 'lv')
                    );
                    commit("SET_TOPONYM_TYPES", sorted);
                });
        },
        async updateData({ dispatch }) {
            await dispatch("getAllToponymsCount");
            await dispatch("getNewestToponym");
            await dispatch("fetchAllToponyms");
            await dispatch("getNewestToponyms");
            await dispatch("getTopActiveUsers");
            await dispatch("getTopAdministrativeTerritories");
        },
    },
};
